// src/components/utils/codeUtils.js
export function normalizeCode(s) {
  return (s || '')
    .trim()
    .toUpperCase()
    .replace(/&/g, 'AND')
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 32);
}

export function slugFromName(name) {
  return normalizeCode((name || '').trim());
}
